module.exports = __webpack_public_path__ + "static/battlerager_MTG_CLB-4ef7c77046db6ca8351571bc29235f1d.webp";